import React from 'react';

import { colors } from '../../components';

const NoContracts = () => (
    <svg
        width="100%"
        height="100%"
        style={{ maxWidth: '240px', maxHeight: '194px' }}
        viewBox="0 0 240 194"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clipPath="url(#clip0_9598_1865)">
            <path
                d="M240 117.714L129.604 80.3625L0 156.118L110.396 193.462L240 117.714Z"
                fill={colors.primaryLight[5]}
            />
            <mask
                id="mask0_9598_1865"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="80"
                width="240"
                height="114"
            >
                <path d="M240 117.714L129.604 80.3625L0 156.118L110.396 193.462L240 117.714Z" fill="white" />
            </mask>
            <g mask="url(#mask0_9598_1865)">
                <path
                    d="M240 107.985L129.604 70.6328L0 146.388L110.396 183.733L240 107.985Z"
                    fill={colors.primaryLight[70]}
                />
            </g>
            <path
                d="M240 103.642L129.604 66.2905L0 142.046L110.396 179.39L240 103.642Z"
                fill={colors.primaryLight[5]}
            />
            <mask
                id="mask1_9598_1865"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="66"
                width="240"
                height="114"
            >
                <path d="M240 103.642L129.604 66.2905L0 142.046L110.396 179.39L240 103.642Z" fill="white" />
            </mask>
            <g mask="url(#mask1_9598_1865)">
                <path
                    d="M240 93.9126L129.604 56.5608L0 132.316L110.396 169.661L240 93.9126Z"
                    fill={colors.primaryLight[30]}
                />
            </g>
            <path d="M240 89.57L129.604 52.2183L0 127.973L110.396 165.318L240 89.57Z" fill={colors.primaryLight[5]} />
            <mask
                id="mask2_9598_1865"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="52"
                width="240"
                height="114"
            >
                <path d="M240 89.57L129.604 52.2183L0 127.973L110.396 165.318L240 89.57Z" fill="white" />
            </mask>
            <g mask="url(#mask2_9598_1865)">
                <path
                    d="M240 79.8403L129.604 42.4885L0 118.244L110.396 155.588L240 79.8403Z"
                    fill={colors.primaryLight[15]}
                />
            </g>
            <path
                d="M240 75.2402L129.604 37.8884L0 113.636L110.396 150.988L240 75.2402Z"
                fill={colors.primaryLight[5]}
            />
            <path
                d="M112.992 137.274C112.957 137.274 112.914 137.274 112.878 137.252L29.6896 109.108C29.5035 109.044 29.4034 108.843 29.4678 108.657C29.5322 108.471 29.7325 108.371 29.9185 108.436L113.107 136.58C113.293 136.644 113.393 136.845 113.329 137.031C113.279 137.181 113.143 137.274 112.992 137.274Z"
                fill={colors.primaryLight[30]}
            />
            <path
                d="M129.196 127.809C129.161 127.809 129.118 127.809 129.082 127.787L45.8937 99.643C45.7076 99.5786 45.6075 99.3782 45.6719 99.1922C45.7363 99.0062 45.9366 98.9061 46.1226 98.9705L129.311 127.115C129.497 127.179 129.597 127.38 129.533 127.566C129.483 127.716 129.347 127.809 129.196 127.809Z"
                fill={colors.primaryLight[30]}
            />
            <path
                d="M145.4 118.337C145.365 118.337 145.322 118.337 145.286 118.315L62.0904 90.1708C61.9044 90.1064 61.8043 89.9061 61.8687 89.7201C61.933 89.5341 62.1334 89.4339 62.3194 89.4983L145.515 117.643C145.701 117.707 145.801 117.907 145.737 118.093C145.687 118.244 145.551 118.337 145.4 118.337Z"
                fill={colors.primaryLight[30]}
            />
            <path
                d="M161.598 108.872C161.562 108.872 161.519 108.872 161.483 108.85L78.295 80.7059C78.109 80.6415 78.0089 80.4412 78.0732 80.2552C78.1376 80.0692 78.3379 79.9691 78.524 80.0334L161.712 108.178C161.898 108.242 161.998 108.443 161.934 108.629C161.884 108.779 161.748 108.872 161.598 108.872Z"
                fill={colors.primaryLight[30]}
            />
            <path
                d="M177.802 99.3999C177.766 99.3999 177.723 99.3999 177.687 99.3784L94.4918 71.234C94.3058 71.1696 94.2056 70.9693 94.27 70.7833C94.3344 70.5973 94.5347 70.4971 94.7207 70.5615L177.916 98.7059C178.102 98.7703 178.202 98.9706 178.138 99.1566C178.088 99.3069 177.952 99.3999 177.802 99.3999Z"
                fill={colors.primaryLight[30]}
            />
            <path
                d="M193.999 89.9348C193.963 89.9348 193.92 89.9348 193.884 89.9133L110.696 61.7689C110.51 61.7045 110.41 61.5042 110.474 61.3182C110.539 61.1322 110.739 61.032 110.925 61.0964L194.113 89.2408C194.299 89.3052 194.399 89.5055 194.335 89.6915C194.285 89.8418 194.149 89.9348 193.999 89.9348Z"
                fill={colors.primaryLight[30]}
            />
            <path
                d="M210.203 80.4626C210.167 80.4626 210.124 80.4626 210.088 80.4412L126.9 52.2968C126.714 52.2324 126.614 52.0321 126.678 51.846C126.743 51.66 126.943 51.5599 127.129 51.6243L210.317 79.7687C210.503 79.833 210.603 80.0334 210.539 80.2194C210.489 80.3696 210.353 80.4626 210.203 80.4626Z"
                fill={colors.primaryLight[30]}
            />
            <path
                d="M120.003 98.8705C142.975 98.8705 161.598 80.2481 161.598 57.2763C161.598 34.3045 142.975 15.6821 120.003 15.6821C97.0315 15.6821 78.4092 34.3045 78.4092 57.2763C78.4092 80.2481 97.0315 98.8705 120.003 98.8705Z"
                fill={colors.primaryLight[15]}
            />
            <path
                d="M143.426 39.6626C154.379 39.6626 163.257 30.7838 163.257 19.8313C163.257 8.87877 154.379 0 143.426 0C132.473 0 123.595 8.87877 123.595 19.8313C123.595 30.7838 132.473 39.6626 143.426 39.6626Z"
                fill={colors.primaryLight[100]}
            />
            <path
                d="M119.595 66.9057C119.202 66.9057 118.88 66.5838 118.88 66.1903V39.7056C118.88 39.3122 119.202 38.9902 119.595 38.9902C119.989 38.9902 120.311 39.3122 120.311 39.7056V66.1903C120.311 66.5838 119.989 66.9057 119.595 66.9057Z"
                fill={colors.primaryLight[100]}
            />
            <path
                d="M134.247 75.8053H104.937C104.543 75.8053 104.221 75.4833 104.221 75.0898V62.1981C104.221 61.8046 104.543 61.4827 104.937 61.4827C105.33 61.4827 105.652 61.8046 105.652 62.1981V74.3744H133.532V62.1981C133.532 61.8046 133.854 61.4827 134.247 61.4827C134.641 61.4827 134.963 61.8046 134.963 62.1981V75.0898C134.963 75.4833 134.641 75.8053 134.247 75.8053Z"
                fill={colors.primaryLight[100]}
            />
            <path
                d="M129.962 50.7874C129.776 50.7874 129.597 50.7159 129.454 50.5799L119.588 40.7144L109.723 50.5799C109.444 50.859 108.993 50.859 108.714 50.5799C108.435 50.3009 108.435 49.8502 108.714 49.5712L119.088 39.1977C119.224 39.0618 119.402 38.9902 119.596 38.9902C119.789 38.9902 119.968 39.0689 120.104 39.1977L130.477 49.5712C130.756 49.8502 130.756 50.3009 130.477 50.5799C130.334 50.723 130.155 50.7874 129.969 50.7874H129.962Z"
                fill={colors.primaryLight[100]}
            />
            <path
                d="M135.392 28.5739C135.206 28.5739 135.027 28.5024 134.884 28.3664C134.605 28.0874 134.605 27.6367 134.884 27.3577L150.952 11.2967C151.231 11.0176 151.682 11.0176 151.961 11.2967C152.24 11.5757 152.24 12.0264 151.961 12.3054L135.893 28.3664C135.75 28.5095 135.571 28.5739 135.385 28.5739H135.392Z"
                fill={colors.primaryLight[5]}
            />
            <path
                d="M151.46 28.5739C151.274 28.5739 151.095 28.5024 150.952 28.3664L134.884 12.3054C134.605 12.0264 134.605 11.5757 134.884 11.2967C135.163 11.0176 135.614 11.0176 135.893 11.2967L151.961 27.3577C152.24 27.6367 152.24 28.0874 151.961 28.3664C151.818 28.5095 151.639 28.5739 151.453 28.5739H151.46Z"
                fill={colors.primaryLight[5]}
            />
        </g>
        <defs>
            <clipPath id="clip0_9598_1865">
                <rect width="240" height="193.462" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

export default NoContracts;
